import React from 'react';

import { Card } from '@/components/ui/card';

export default function CheckoutTimeHintsSection({
  estimateDeliveryTxt,
  estimateRetiroTxt,
  estimateMesaTxt,
}) {
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">{'\u23F1\uFE0F'} Tiempo estimado</h2>
      <div className="space-y-2 text-sm text-muted-foreground">
        {estimateDeliveryTxt && (
          <p>
            {'\u{1F69A}'} Delivery: {estimateDeliveryTxt}
          </p>
        )}
        {estimateRetiroTxt && (
          <p>
            {'\u{1F6CD}\uFE0F'} Retiro: {estimateRetiroTxt}
          </p>
        )}
        {estimateMesaTxt && (
          <p>
            {'\u{1F37D}\uFE0F'} Mesa: {estimateMesaTxt}
          </p>
        )}
      </div>
    </Card>
  );
}
